import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "animation" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", {
    class: 
      `btn 
    btn-${_ctx.btnType ? _ctx.btnType : 'primary'} 
    btn-${_ctx.icon ? 'arrow' : ''}-${_ctx.iconAlign ? _ctx.iconAlign : 'right'}
    btn-${_ctx.size ? _ctx.size : 'md'}
    btn-${_ctx.fullWidth ? 'fullWidth' : ''}
    btn-${_ctx.outline ? 'outline' : ''}
    `
    ,
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkto(_ctx.to)))
  }, [
    _hoisted_1,
    _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
  ], 2))
}